<div class="grid-container">
  <div aria-live="polite" class="visuallyhidden" tabIndex="-1" #focusElement>{{ ariaLiveMessage }}</div>
  <router-outlet></router-outlet>
</div>
